export default "__VITE_ASSET__32831f68__"